"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroSpaceGridCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
var Skeleton_1 = __importDefault(require("@atg/icf-react-components/components/Skeleton"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var getStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    action: {
        width: "100%",
        position: "absolute",
        bottom: "".concat(theme.spacing.base, "px"),
        display: "flex",
        justifyContent: "center",
        alignItems: "end",
        boxSizing: "border-box",
        zIndex: 2,
        "& > a": {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            padding: [0, theme.spacing.base * 3],
            boxSizing: "border-box",
        },
    },
    hero: {
        width: "100%",
        height: "100%",
        position: "absolute",
    },
}); });
var HeroSpaceGridCard = function (_a) {
    var heroBannerImage = _a.heroBannerImage;
    var theme = (0, react_jss_1.useTheme)();
    // @ts-ignore
    var classes = getStyles({ theme: theme });
    return ((0, jsx_runtime_1.jsx)(Ioc_1.ContextConsumer, { contexts: [Contexts_1.ILinkComponentContext, Contexts_1.ITranslationServiceContext], children: function (Link, _a) {
            var translate = _a.translate;
            return ((0, jsx_runtime_1.jsxs)(Link, { to: "/signup/register", children: [(0, jsx_runtime_1.jsx)("div", { className: classes.hero, "data-ta-locator": "hero-banner-card", children: (0, jsx_runtime_1.jsx)(Skeleton_1.default, { types: ["circle", "line", "line", "line"], hasBackground: false }) }), (0, jsx_runtime_1.jsx)("div", { className: classes.hero, children: heroBannerImage }), (0, jsx_runtime_1.jsx)("div", { className: classes.action, children: (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { gold: true, label: translate("hero_slider.free_account") }) })] }));
        } }));
};
exports.HeroSpaceGridCard = HeroSpaceGridCard;
//# sourceMappingURL=HeroSpaceGridCard.js.map